$(function () {
    const $banner = $('#ad-banner-header');

    if ($banner.length) {
        // Load the banner
        $.get('/ads', function (ad) {
            $banner.html('<a href="' + ad.href + '" target="_blank"><img src="' + ad.img + '" class="ad-banner-img" alt="Banner" /></a>');
        });
    }
});
